import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    departmentData: {},
};

const departmentSlice = createSlice({
    name: "department",
    initialState,
    reducers: {
        setdepartmentData(state, action) {
            state.departmentData = action.payload
        },
    },
});

export const { setdepartmentData } = departmentSlice.actions;

export default departmentSlice.reducer;

